
export const cursor = {
  name: 'cursor'
}

export const userSelect = {
  name: 'user-select'
}

export const visibility = {
  name: 'visibility'
}

export const pointerEvents = {
  name: 'pointer-events'
}